// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3JeNL","row":"ProcedureTreatmentSummary_row__hellQ"};